import React from "react";
import "./index.less";
import Mileage from '../Mileage/index';
export default ({ value = ['', ''], onChange, opts={}}) => {
    const [value1 , value2] = value;
    
    return (
      <div className={"TUI-MileageRange"}>
        <Mileage value={value1} onChange={v => {
            onChange([v, value2])
          }} opts={opts}/>
        <Mileage value={value2} onChange={v => {
            onChange([value1, v])
          }} opts={opts}/>
      </div>
    )
}